// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__80dQH","root":"Layout_root__mL46b"};